import { format, getZonedDate } from '@eika-infrastruktur/date';
import { capitalize } from '@eika-infrastruktur/format';
import { ExpandTableRow } from '@eika/expand-table';

import { currencyFormatter } from '../../components/shared/numberFormat';
import type { LoanRepaymentPlan } from '../../generated-types';

const formatLoanRepaymentPlan = (plan: LoanRepaymentPlan): ExpandTableRow[] => {
    return plan.paymentDetails.map((paymentDetails) => {
        const annualDetails = paymentDetails.details.find((details) => details.annualDetails);
        const rowElements = [
            paymentDetails.year.toString(),
            currencyFormatter(annualDetails?.payment, 'NOK'),
            currencyFormatter(annualDetails?.instalment, 'NOK'),
            currencyFormatter(annualDetails?.interest, 'NOK'),
            currencyFormatter(annualDetails?.charges, 'NOK'),
            currencyFormatter(annualDetails?.balance, 'NOK'),
        ];
        const subTable = paymentDetails.details
            .filter((details) => !details.annualDetails)
            .map((details) => {
                const rowElements = [
                    capitalize(format(getZonedDate(details.eventDate), 'MMMM')),
                    currencyFormatter(details.payment, 'NOK'),
                    currencyFormatter(details.instalment, 'NOK'),
                    currencyFormatter(details.interest, 'NOK'),
                    currencyFormatter(details.charges, 'NOK'),
                    currencyFormatter(details.balance, 'NOK'),
                ];
                return { id: getZonedDate(details.eventDate).getTime().toString(), rowElements };
            });

        return { id: paymentDetails.year.toString(), rowElements, subTable };
    });
};

export default formatLoanRepaymentPlan;
